import React, { useContext, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { StepperContext } from './index';
import { Check } from 'react-feather';
import { Tooltip } from 'reactstrap';

const StepperBadge = ({
	active,
	validated,
	disabled,
	no_click,
	label,
	title,
	onClick,
	style
}) => {
	const [showTooltip, setShowTooltip] = useState(false);
	return (
		<Box className="stepper_badge" onClick={onClick} style={style}>
			<Box
				id={`stepper-step_${label}`}
				className={`stepper_badge_element${
					active
						? '-active'
						: validated
						? '-validated'
						: disabled
						? '-disabled'
						: ''
				}${no_click || disabled ? ' stepper_badge_element-no_click' : ''}`}
				onMouseOver={() => {
					setShowTooltip(true);
				}}
				onMouseOut={() => {
					setShowTooltip(false);
				}}
			>
				<Box
					as={'span'}
					style={{ position: 'relative' }}
					className={`stepper_badge_label${
						active
							? '-active'
							: validated
							? '-validated'
							: disabled
							? '-disabled'
							: ''
					}`}
				>
					{label}
					{!active && validated && (
						<Box
							style={{
								position: 'absolute',
								bottom: '-.5rem',
								right: '-.7rem'
							}}
						>
							<Flex
								alignItems="center"
								justifyContent="center"
								backgroundColor="#007425"
								border="solid 1px white"
								borderRadius="50%"
								p={1}
							>
								<Check size={12} />
							</Flex>
						</Box>
					)}
				</Box>
			</Box>
			<Tooltip
				placement="top"
				isOpen={showTooltip}
				target={`stepper-step_${label}`}
			>
				{title}
			</Tooltip>
		</Box>
	);
};

const StepperHeader = ({ hide }) => {
	const { stepperState, setStepperState } = useContext(StepperContext);
	const { steps, elements, currentIndex, currentStep } = stepperState;
	const Component = elements[currentIndex].render
		? elements[currentIndex].render
		: () => <></>;
	return (
		!hide.includes(currentIndex) && (
			<Flex position={'relative'} width={'calc(80% - 10rem)'} height={'100%'}>
				<Flex
					width={'100%'}
					justifyContent={'space-between'}
					className={'stepper_header'}
				>
					{Object.keys(steps).map((key, index) => {
						const step = steps[key];
						return (
							step.label && (
								<StepperBadge
									key={`header-${key}${index}`}
									active={currentStep === key}
									validated={steps[key]?.validated}
									no_click={steps[key]?.no_click}
									disabled={steps[key]?.validated}
									label={step.label}
									title={step.title}
									onClick={() => {
										if (!(steps[key]?.no_click || steps[key]?.disabled)) {
											steps[key]['validated'] = false;
											setStepperState({
												...stepperState,
												currentIndex: elements.findIndex((s) => s.step === key),
												currentStep: key
											});
										}
									}}
								/>
							)
						);
					})}
				</Flex>
				{<Component />}
			</Flex>
		)
	);
};

export { StepperBadge, StepperHeader };
